<template lang='pug'>
#listar-monitoramento-agricola
        BaseHeader(
            :titulo="$t('mensagens.monitoramentoAgricola.baseHeader.titulo')"
            icon='el-icon-circle-plus-outline'
            :btnTexto="$t('mensagens.monitoramentoAgricola.baseHeader.botao')"
            :exibeBotao='true'
            @btnHeaderClicado='btnHeaderClicado'
        )

        .view-container-base-header
            .margin-top
                FiltrarMonitoramentoAgricola(
                    :cultura='culturaSelecionada',
                    :filtroAlerta='filtroAlerta'
                    @atualizar-filtro-avancado='atualizarFiltroAvancado'
                    @remover-cultura-selecionada='removerCulturaSelecionada'
                )
            BlocoAlertaMonitoramentoAgricola(
                :periodoAlerta='periodoAlerta'
            )
            BlocoCulturaMonitoramentoAgricola(
                :remover-cultura='removerCultura'
                @atualizar-filtro-avancado='atualizarFiltroAvancado'
            )
            .container-totalizadores
                h3 {{ $t('mensagens.monitoramentoAgricola.totalizadores.titulo') }}
                .totalizadores-lista
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.numeroTerritorios')",
                        :numero='totalizadores.qdeTerritorios'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-territorio
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.areaMonitorada')",
                        :numero='totalizadores.areaMonitorada'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-hectare-monitorado
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.areaPlantadaConfirmada')",
                        :numero='totalizadores.areaPlantadaConfirmada'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-quadro
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.produtividadeMedia')",
                        :numero='internacionalizacaoTotalizadores(totalizadores.produtividadeMedia)'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-grafico-2
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.producao')",
                        :numero='internacionalizacaoTotalizadores(totalizadores.producao)'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-trator-producao
                    BaseBlocoTotalizador(
                        :texto="$t('mensagens.monitoramentoAgricola.totalizadores.estimativaInicioProximaColheita')",
                        :numero='internacionalizacaoTotalizadores(totalizadores.estimativaInicioColheita)'
                    )
                        template(slot='icone')
                            i.lyra-icon.lyra-relogio

            .margin-top
                BlocoEvolucaoMonitoramentoAgricola(:filtros='filtros')
                ListaMonitoramentoAgricola(:filtros='filtros',@buscarTotalizadores='buscarTotalizadores')
</template>

<script>
import BlocoEvolucaoMonitoramentoAgricola from '@/components/monitoramento/BlocoEvolucaoMonitoramentoAgricola';
import BaseHeader from '@/components/BaseHeader';
import BlocoCulturaMonitoramentoAgricola from '@/components/monitoramento/BlocoCulturaMonitoramentoAgricola';
import BaseBlocoTotalizador from '@/components/monitoramento/BaseBlocoTotalizador';
import BlocoAlertaMonitoramentoAgricola from '@/components/monitoramento/BlocoAlertaMonitoramentoAgricola';
import FiltrarTerritorioMonitoramento from '@/components/monitoramento/FiltrarTerritorioMonitoramento';
import ListaMonitoramentoAgricola from '@/components/monitoramento/ListaMonitoramentoAgricola';
import FiltrarMonitoramentoAgricola from '@/components/monitoramento/FiltrarMonitoramentoAgricola.vue';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'index',
    components: {
        BaseHeader,
        BlocoCulturaMonitoramentoAgricola,
        BaseBlocoTotalizador,
        BlocoAlertaMonitoramentoAgricola,
        FiltrarTerritorioMonitoramento,
        ListaMonitoramentoAgricola,
        FiltrarMonitoramentoAgricola,
        BlocoEvolucaoMonitoramentoAgricola
    },
    data() {
        return {
            filtros: {
                idCulturas: [],
                idSafras: [],
                possuiAlertas: null,
                idRepresentantes: [],
                idTerritorios: []
            },
            totalizadores: [],
            culturaSelecionada: '',
            removerCultura: {
                remover: false,
                id: null
            },
            periodoAlerta: null,
            filtroAlerta: false
        };
    },

    beforeRouteLeave(to, from, next) {
        if (to.name !== 'MonitoramentoAgricolaImovel') {
            this.limparCulturaFiltrada();
            this.limparFiltroMonitoramento();
        }
        next(true);
    },

    watch: {
        filtros: function() {
            this.buscarTotalizadores();
        }
    },
    computed: {
        ...mapGetters(['filtroMonitoramento', 'culturaFiltrada'])
    },

    created() {
        if (this.filtroMonitoramento) {
            this.atualizarFiltroAvancado(this.filtroMonitoramento, this.culturaFiltrada);
        }
        if (this.$route.params.periodoAlertaAgricola) {
            let param = this.$route.params.periodoAlertaAgricola;

            if (isNaN(param)) {
                this.periodoAlerta = param;
                this.filtroAlerta = true;
            }
        }

        this.buscarTotalizadores();
    },

    methods: {
        ...mapActions(['limparCulturaFiltrada', 'limparFiltroMonitoramento']),

        btnHeaderClicado: function() {
            this.$router.push({ name: 'CadastrarMonitoramentoAgricola' });
        },
        removerCulturaSelecionada(cultura) {
            this.removerCultura = {
                remover: true,
                id: cultura
            };
        },
        atualizarFiltroAvancado(filtros, cultura) {
            this.filtros = {
                ...this.filtros,
                ...filtros
            };
            this.culturaSelecionada = cultura;
        },

        buscarTotalizadores() {
            MonitoramentoAgricolaService.buscarTotalizadores(this.filtros)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.totalizadores = data;
                    }, 500);
                })
                .catch(error => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.monitoramentoAgricola.erros.buscarTotalizadores')
                    });
                    throw error;
                });
        },
        internacionalizacaoTotalizadores(data) {
            if (data === 'Cultura não selecionada') {
                return this.$t('mensagens.monitoramentoAgricola.culturaNaoSelecionada');
            } else return data;
        }
    }
};
</script>

<style lang='scss' scoped>
#listar-monitoramento-agricola {
    .margin-top {
        margin-top: 15px;
    }

    .lyra-territorio::before, .lyra-hectare-monitorado::before, .lyra-trator-producao::before{
        content: '';
        height: 32px !important;
        width: 32px !important;
    }

    .container-totalizadores {
        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
            font-weight: 500;
        }

        .totalizadores-lista {
            width: 100%;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 33.33% 33.33% 33.33%;
        }

        .totalizadores-bloco {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
